import React from 'react';
import { string, func } from 'prop-types';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { withLayoutGroup } from '@thd-olt-component-react/layout-manager';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { PackageHeader } from './subcomponents/PackageHeader';
import { PackageInfo } from './subcomponents/PackageInfo';
import './packages-mini.scss';
import { dataModel } from './dataModel';
import { PackagesMiniPlaceholder } from './loader/packagesMiniLoader';
import PackagesMiniProvider from './PackagesMiniProvider';

const PackagesMiniComponent = ({ itemId, callOnLoaded }) => (
  <div className="packages-mini" data-testid="packages-mini">
    <PackagesMiniProvider
      itemId={itemId}
      callOnLoaded={callOnLoaded}
      placeholder={<PackagesMiniPlaceholder />}
    >
      <PackageHeader />
      <PackageInfo />
    </PackagesMiniProvider>
  </div>
);

const propTypes = {
  itemId: string,
  callOnLoaded: func
};

const defaultProps = {
  itemId: '',
  callOnLoaded: () => {},
};

PackagesMiniComponent.displayName = 'PackagesMini';
PackagesMiniComponent.propTypes = propTypes;
PackagesMiniComponent.defaultProps = defaultProps;
PackagesMiniComponent.dataModel = dataModel;

const HydratedComponent = withHydrator({
  id: 'product-section-packages-mini',
  scrollBuffer: 100,
  delay: 1500,
  preserveCtxVal: 'clientStore',
  placeholder: <PackagesMiniPlaceholder />
}, PackagesMiniComponent);

const DynamicComponent = withDynamicComponent(HydratedComponent, { placeholder: <PackagesMiniPlaceholder /> });
const PackagesMini = withLayoutGroup({
  name: 'packages-mini'
}, DynamicComponent);
PackagesMini.propTypes = propTypes;
PackagesMini.defaultProps = defaultProps;
PackagesMini.dataModel = dataModel;
PackagesMini.displayName = 'PackagesMini';
export { PackagesMini };
